import React from 'react';
import { FaUsers } from 'react-icons/fa';
import styled from 'styled-components';

const IconButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: #2563eb;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: #f3f4f6; }
`;

const Badge = styled.span`
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: #ef4444;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
`;

export default function TeamworkButton({ count = 0, overdue = false, onClick }) {
  return (
    <IconButton onClick={onClick} aria-label="Teamwork" style={overdue ? { color: '#ef4444' } : undefined}>
      <FaUsers size={22} />
      {count > 0 && <Badge>{count}</Badge>}
    </IconButton>
  );
}
